<template>
  <v-dialog :value="value" max-width="560" @input="$emit('input', $event)">
    <v-card>
      <v-card-title>Contacter le support</v-card-title>
      <v-card-text>
        <v-text-field v-model="subject" label="Sujet" outlined dense maxlength="200" />
        <v-select v-model="category" :items="categories" label="Catégorie" outlined dense />
        <v-textarea v-model="description" label="Décrivez votre demande" rows="4" auto-grow outlined dense />
        <div v-if="prefillLinks.length" class="text-caption grey--text">
          Cette demande sera liée à l'élément en cours.
        </div>
        <v-alert v-if="error" type="error" dense text class="mt-2 mb-0">{{ error }}</v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$emit('input', false)">Annuler</v-btn>
        <v-btn color="primary" elevation="0" :loading="sending" :disabled="!canSend" @click="submit">
          Envoyer
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createTicket } from '@/services/supportApi'

export const CATEGORIES = [
  { value: 'bug', text: 'Bug' },
  { value: 'question', text: 'Question' },
  { value: 'brief_quality', text: 'Qualité du brief' },
  { value: 'catalog_stock', text: 'Catalogue / stock' },
  { value: 'account', text: 'Compte' },
  { value: 'other', text: 'Autre' },
]

export default {
  name: 'SupportNewDialog',
  props: {
    value: { type: Boolean, default: false },
    prefillLinks: { type: Array, default: () => [] },
  },
  data: () => ({
    subject: '',
    description: '',
    category: 'other',
    categories: CATEGORIES,
    sending: false,
    error: '',
  }),
  computed: {
    canSend() {
      return this.subject.trim() && this.description.trim() && !this.sending
    },
  },
  methods: {
    async submit() {
      this.sending = true
      this.error = ''
      try {
        const ticket = await createTicket({
          subject: this.subject.trim(),
          description: this.description.trim(),
          category: this.category,
          links: this.prefillLinks,
        })
        this.subject = this.description = ''
        this.$emit('input', false)
        this.$emit('created', ticket)
        this.$store.dispatch('support/loadCounts')
        this.$router.push({ name: 'ticket_detail', params: { id: ticket.id } })
      } catch (e) {
        this.error = "Impossible d'envoyer la demande. Vérifiez les champs et réessayez."
      } finally {
        this.sending = false
      }
    },
  },
}
</script>
